import { Provider } from 'react-redux';
import { createStore } from 'redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { checkBrowser } from '../../helpers/browserCheck';
import {
  Image360CarouselContainer,
  ImageCarouselContainer,
  PriceBreakContainer,
  SearchMessageContainer,
  LinkedProductContainer,
  TechnicalDocumentContainer,
  RelatedCategoryContainer,
  CalibratedProductContainer,
} from './containers/';
import reducer from './store';
import { initialImageCarouselState } from './store/middleware/';

const store = createStore(reducer, initialImageCarouselState);
const calibrationAlternativesDisplayEnabled = rs.web.product.model.calibrationAlternativesDisplayEnabled;

ReactDOM.render(
  <Provider store={store} >
    { window.cloudinary && checkBrowser() ? <Image360CarouselContainer /> : <ImageCarouselContainer /> }
  </Provider>,
  document.getElementById('image-carousel'),
);

if (document.getElementById('price-break-container')) ReactDOM.render(<PriceBreakContainer />, document.getElementById('price-break-container'));
ReactDOM.render(<SearchMessageContainer />, document.getElementById('search-message-container'));
ReactDOM.render(<LinkedProductContainer />, document.getElementById('linked-products-container'));
ReactDOM.render(<TechnicalDocumentContainer />, document.getElementById('technical-document-container'));
ReactDOM.render(<RelatedCategoryContainer />, document.getElementById('related-category-container'));
if (calibrationAlternativesDisplayEnabled) ReactDOM.render(<CalibratedProductContainer />, document.getElementById('calibrated-products-container'));



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/index.js